import { render, staticRenderFns } from "./ReviewsAnalytic.vue?vue&type=template&id=e48df602&"
import script from "./ReviewsAnalytic.vue?vue&type=script&lang=js&"
export * from "./ReviewsAnalytic.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAnalytic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports